
export default {
  busStopPublic:
    "https://services1.arcgis.com/vVI5TNykiYD9EhM5/ArcGIS/rest/services/Stotel%c4%97s/FeatureServer/0",

  schoolPre:
    "https://opencity.idvilnius.lt/server/rest/services/Hosted/Ikimokyklinio_ugdymo_istg/FeatureServer/21", // pakeistas
  schoolElementary:
    "https://opencity.idvilnius.lt/server/rest/services/Hosted/Pradinio_ugdymo_istg/FeatureServer/18", // pakeistas
  schoolBasic:
    "https://opencity.idvilnius.lt/server/rest/services/Hosted/Vidurinio_ugdymo_istg/FeatureServer/15", // pakeistas
  schoolHigher:
    "https://opencity.idvilnius.lt/server/rest/services/Hosted/Aukstojo_mokslo_istg/FeatureServer/12", // pakeistas

  hospitals:
    "https://opencity.idvilnius.lt/server/rest/services/Hosted/Ligonines/FeatureServer/6", // pakeistas
  dentist:
    "https://opencity.idvilnius.lt/server/rest/services/Hosted/Medicinos_ir_odontologijos_istg/FeatureServer/9", // pakeistas

  statePublicOffices:
    "https://opencity.idvilnius.lt/server/rest/services/Hosted/Administraciniai_pastatai/FeatureServer/0", // pakeistas

  busRoutes:
    "https://arcgis.sisp.lt/arcgis/rest/services/VT/VT_marsutu_trasos/FeatureServer/0",

  blackSpots:
    "https://gis.vplanas.lt/arcgis/rest/services/Interaktyvus_zemelapis2/Transportas_VMSA/MapServer/66",

  parking:
    "https://services1.arcgis.com/vVI5TNykiYD9EhM5/ArcGIS/rest/services/Parkomatai_2024_05_21/FeatureServer/0",

  bikeParking:
    "https://services1.arcgis.com/vVI5TNykiYD9EhM5/ArcGIS/rest/services/Tikslios_saugykl%c5%b3_vietos/FeatureServer/0",

  wazeHistory:
    "https://arcgis.sisp.lt/arcgis/rest/services/Waze/Waze_History_public/FeatureServer/0",

  bikeSensors:
    "https://arcgis.sisp.lt/arcgis/rest/services/Dviračių_jutiklių_duomenys/FeatureServer/0",

  walkingRoads:
    "https://opencity.idvilnius.lt/portal/sharing/servers/4f17cd73f6a248048b8d1938ed778789/rest/services/MUD/MUD_taku_bukle_REDAGAVIMAS/MapServer/1"
};
